import React from 'react';

import { Help, CircleAdd } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import styles from 'components/BundleBuilderPage/BundleBuilderPage.scss';
import { GroupItemPlaceholderProps } from 'components/Builder/types';

const BundleLineItemPlaceholder = ({ completed = false }: GroupItemPlaceholderProps) => {
  return completed ? (
    <div className={styles.completeWrapper}>
      <Typography className={styles.lineTitle} element="p" noMargins>
        Why not add more
      </Typography>
    </div>
  ) : (
    <div className={styles.placeholderWrapper}>
      <Help size="large" className={styles.helpIcon} />
      <CircleAdd size="large" className={styles.circleAddIcon} />
    </div>
  );
};

export default BundleLineItemPlaceholder;
